import React, { useState } from "react";
//-----------libraries--------------//
import { Button, Space, Table, Tag, Modal, Menu, Dropdown, Pagination } from "antd";
import "./Assistant.css";
//--------------helper ------------//
import { showDeleteConfirm } from "../../Utility/assistant-helper";

import {
  AiOutlineDelete,
  AiOutlineInfo,
  AiOutlineArrowUp,
  AiOutlineThreeDotsVertical,
} from "react-icons/ai";

//-------api----------//
import { fetchAssistantsCreatedByUser } from "../../api/assistant";
import DebouncedSearchInput from "../../Pages/SuperAdmin/Organizations/DebouncedSearchInput";
import { BsRobot, BsThreeDotsVertical } from "react-icons/bs";
//-----Helper----------//
import { redirectToAssistant } from "../../Utility/assistant-helper";
import { IoMdInformationCircleOutline } from "react-icons/io";
import { IoChatbubbleEllipsesOutline } from "react-icons/io5";
import ProfileHeader from "../Proflie/ProfileHeader";
import "./Assistant.css";

const UserAssistantList = ({ data }) => {
  const { userAssistants, loader, handleDeleteAssistant } = data;
  const [expandedData, setExpandedData] = useState([]);
  const [isInfoModalVisible, setIsInfoModalVisible] = useState(false);
  const [prefilledData, setPrefilledData] = useState({});
  const [searchQuery, setSearchQuery] = useState("");
  const [pageSize, setPageSize] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);


  
  //---------local functions -----------//
  const showInfoModal = (record) => {
    setPrefilledData(record);
    setIsInfoModalVisible(true);
  };

  const redirectToAssistant = (record) => {
    const assistantId = record.assistant_id;
    const url = `/agents/${assistantId}`;
    window.open(url, "_blank");
  };

  const handleInfoModalCancel = () => {
    setIsInfoModalVisible(false);
  };

  //---On expand Api Call---------??
  const onExpand = async (expanded, record) => {
    if (expanded && !expandedData[record._id]) {
      try {
        const response = await fetchAssistantsCreatedByUser(1, record._id);
        if (response) {
          const assistantsCreatedByUser = response?.data || [];

          setExpandedData(
            assistantsCreatedByUser.map((assistant, index) => ({
              key: index.toString(),
              name: assistant?.name,
              instruction: assistant?.instructions,
              is_active: assistant?.is_active,
              assistant_id: assistant?.assistant_id,
              description: assistant?.description,
            }))
          );
        }
      } catch (error) {
        console.error("Error fetching assistants created by user:", error);
      }
    }
  };

  const expandedRowRender = () => {
    const columns = [
      {
        title: "Agent",
        dataIndex: "name",
        key: "name",
        align: "left",
        render: (_, { name, image_url }) => (
          <Space size="middle" className="d-flex align-items-center">
            <div className="assistantImageDiv">
              {image_url ? (
                <img src={image_url} className="customImage" alt="avatar" />
              ) : (
                <BsRobot className="customImage" />
              )}
            </div>
            <div className="ms-2 text-start">{name}</div>
          </Space>
        ),
      },
      {
        title: "Instruction",
        dataIndex: "instruction",
        key: "instruction",
        align: "left",
      },
      {
        title: "Status",
        key: "is_active",
        align: "center",
        dataIndex: "is_active",
        width: 100,
        render: (_, { is_active = false }) => (
          <Tag color={is_active ? "green" : "red"}>
            {is_active ? "active" : "inactive"}
          </Tag>
        ),
      },

      {
        title: "Action",
        key: "action",
        align: "center",
        render: (_, record) => (
          <Space size="middle">
            <Button
              onClick={() => redirectToAssistant(record)}
              icon={<AiOutlineArrowUp />}
            ></Button>

            <Button
              onClick={() => showInfoModal(record)}
              icon={<AiOutlineInfo />}
              disabled={loader.ASSISTANT_LOADING}
            ></Button>
            <Button
              onClick={() =>
                showDeleteConfirm(
                  record?.assistant_id,
                  record?.name,
                  handleDeleteAssistant
                )
              }
              danger
              icon={<AiOutlineDelete />}
              loading={loader.ASSISTANT_DELETING === record.assistant_id}
            />
          </Space>
        ),
      },
    ];

    return (
      <Table columns={columns} dataSource={expandedData} pagination={false} />
    );
  };

  const createActionMenu = (record) => {
    return (
      <Menu>
        <Menu.Item key="redirect">
          <span
            style={{ display: "flex", alignItems: "center", gap: "8px" }}
            onClick={() => redirectToAssistant(record)}
          >
            <IoChatbubbleEllipsesOutline /> Redirect to Assistant
          </span>
        </Menu.Item>
        <Menu.Item key="info">
          <span
            style={{ display: "flex", alignItems: "center", gap: "8px" }}
            onClick={() => showInfoModal(record)}
            disabled={loader.ASSISTANT_LOADING}
          >
            <IoMdInformationCircleOutline /> View Info
          </span>
        </Menu.Item>
        <Menu.Item key="delete" danger>
          <span
            style={{ display: "flex", alignItems: "center", gap: "8px" }}
            onClick={() =>
              showDeleteConfirm(
                record?.assistant_id,
                record?.name,
                handleDeleteAssistant
              )
            }
          >
            <AiOutlineDelete /> Delete
          </span>
        </Menu.Item>
      </Menu>
    );
  };

  const columns = [
    {
      title: "Person Name",
      dataIndex: "username",
      key: "username",
      align: "left",
      render: (text) => <span className="text-left">{text}</span>,
    },
    {
      title: "Total Agents",
      dataIndex: "totalAssistants",
      key: "totalAssistants",
      align: "center",
    },
  ];

  // Filter assistant based on search term
  const filteredUser = userAssistants?.filter((assistant) => {
    return assistant.username.toLowerCase().includes(searchQuery.toLowerCase());
  });

  return (
      <div>
        <div className="mb-3">
          <ProfileHeader
            title="User Agents"
            subHeading="Interact with user-specific AI agents"
          />
        </div>
          <div className="searchbox-container">
          <div
            className={`${
              filteredUser?.length === 0
                ? "searchbox-agent-loading-state mt-0"
                : "searchbox-wrapper"
            }`}
          >
            <DebouncedSearchInput
              data={{
                search: searchQuery,
                setSearch: setSearchQuery,
                placeholder: "Search users",
              }}
            />
          </div>
            <Pagination
            current={currentPage}
            pageSize={pageSize}
            total={filteredUser?.length || 0}
            showSizeChanger={true}
            onShowSizeChange={(current, size) => {
              setPageSize(size);
              setCurrentPage(1);
            }}
            onChange={(page) => setCurrentPage(page)}
            showTotal={(total, range) => `${range[0]}-${range[1]} of ${total} items`}
          />
        </div>
          <Table
          className={`${filteredUser?.length === 0 ? "mt-3" : "mt-0"}`}
          loading={loader.ASSISTANT_STATS_LOADING}
          expandable={{
            expandedRowRender,
            defaultExpandedRowKeys: ["0"],
            onExpand: (record, event) => {
              onExpand(record, event);
            },
          }}
          columns={columns}
          dataSource={filteredUser}
          scroll={{ y: "50vh" }}
          pagination={false}
        />
    
        <Modal
          title="Agent Information"
          open={isInfoModalVisible}
          onCancel={handleInfoModalCancel}
          footer={null}
        >
          <p>
            <b>Name:</b> {prefilledData?.name}
          </p>
          <p>
            <b>Instruction:</b> {prefilledData?.instruction}
          </p>
          <p>
            <b>Description:</b> {prefilledData?.description}
          </p>
        </Modal>
      </div>
    );  
};

export default UserAssistantList;
